<template>
    <div>
        <div class="panel panel-default">
            <!--试卷基础信息-->
            <div class="panel-heading">
                <h4 class="panel-title"><i class="fa fa-book"></i>试卷基础信息</h4>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="well">
                            <h4>试卷名称：{{ model.sjmc }}</h4>
                            <h4>课程名称：{{ model.kcmc }}</h4>
                            <h4>试卷类型：{{ model.sjfl | getSjfl }}</h4>
                        </div>
                    </div>
                </div>
            </div>
            <!--组卷规则设置-->
            <div class="panel-heading">
                <h4 class="panel-title"><i class="fa fa-bookmark"></i>组卷规则设置</h4>
            </div>
            <div class="panel-body">
                <div class="panel panel-primary" style="margin: 15px;">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-sm-12" >
                                <div class="panel panel-default" style="margin: 15px;" v-for="(item,index) in model.questionList" :key = "index">
                                    <div class="panel-heading" >
                                        题型：[{{ item.text }}]
                                    </div>
                                    <div class="panel-body">
                                        <form class="form-horizontal">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label class="col-sm-3 control-label">试题难度</label>
                                                        <div class="col-sm-9">
                                                            <select name="stnd" v-model="item.stnd" class="form-control" data-vv-as="试题难度" @change="changeND(item.stlb, item.stnd, item.tkId)">
                                                                <option value="">-请选择-</option>
                                                                <option v-for="stnd in stndList" :key="stnd.value" :value="stnd.value">{{stnd.text}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label class="col-sm-3 control-label">所属题库</label>
                                                        <div class="col-sm-5">
                                                            <select name="tkId" v-model="item.tkId" class="form-control" data-vv-as="所属题库" @change="changeTk(item.stlb, item.tkId, item.stnd)">
                                                                <option value="">-请选择-</option>
                                                                <option v-for="tk in tkList" :key="tk.id" :value="tk.id">{{tk.tkmc}}</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <p>可选总题数[<span style="color: red;">{{item.zsl?item.zsl:0}}</span>]</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label class="col-sm-3 control-label">数量</label>
                                                        <div class="col-sm-9">
                                                            <input name="sl" v-model="item.sl" type="text" class="form-control" v-on:input="updateTotalScore" @blur="verifyCount(item.stlb, item.sl, item.zsl)">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label class="col-sm-3 control-label">每题分值</label>
                                                        <div class="col-sm-9">
                                                            <input name="fz" v-model="item.fz" type="text" class="form-control" v-on:input="updateTotalScore">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12" style="text-align: center;margin-bottom: 10px">
                        <span style="font-weight: bold;">卷面总分:</span>
                        <span style="color: red" >{{model.jmzf?model.jmzf:0}}</span>
                        <span style="margin-left: 30px;font-weight: bold;">及格分数 :</span>
                        <span style="color: red" >{{model.jgfs?model.jgfs:0}}</span>
                    </div>
                    <div class="col-sm-12 text-center">
                        <button @click="save()" type="button" class="btn btn-primary btn-sm " style="margin-right:3px"><i class="" aria-hidden="true"></i>提交</button>
                        <button @click="cancel()" type="button" class="btn btn-primary btn-sm " style="margin-right:3px"><i class="" aria-hidden="true"></i>取消</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /**
     * 综合测验-自动组卷
     */
    export default {
        name:"ExamPaperZdzj",
        data:function(){
            return {
                // 角色
                js:this.$store.state.user.js,
                // 样式
                lxStyle: {
                    marginBottom: '15px'
                },
                // 题库
                tkList:[],
                // 试题难度
                stndList:[],
                // 数据
                model:{
                    questionList:[
                        {
                            stlb: 'SINGLECHOICE',
                            text: '单选题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'MULTIPLECHOICE',
                            text: '多选题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'JUDGMENT',
                            text: '判断题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'BLANKFILL',
                            text: '填空题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'ESSAY',
                            text: '问答题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'MCJST',
                            text: '名词解释题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'LST',
                            text: '论述题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'JDT',
                            text: '简答题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        },
                        {
                            stlb: 'TT',
                            text: '套题',
                            stnd: '', // 试题难度
                            tkId:'',//所属题库
                            zsl:0,//总题数
                            sl:0, //数量
                            fz:0 //分值
                        }
                    ],
                    // ID
                    id: this.$route.query.id,
                    // 课程
                    kcId: this.$route.query.kcId,
                    // 试卷分类
                    sjfl: this.$route.query.sjfl,
                    // 试卷名称
                    sjmc: this.$route.query.sjmc,
                    // 课程名称
                    kcmc: this.$route.query.kcmc,
                    // 卷面总分
                    jmzf:'',
                    // 及格分数
                    jgfs:''
                }
            }
        },
        computed:{

        },
        filters: {
            getSjfl (value) {
                if (value === 'ZHCY') {
                    return '综合测验'
                } else {
                    return ''
                }
            }
        },
        created:function(){
            this.$store.commit('setBreadcrumb', [{name: '职业培训'}, {name: '在线培训'}, {name: '试卷管理'}, {name: '综合测验'},{name:'自动组卷'}]);
            this.$store.commit('setShowReturnBackBtn',true);
            // 试题难度
            this.stndList = [{value: 'FCRY', text: '非常容易'}, {value: 'BJRY', text: '比较容易'}, {value: 'CG', text: '常规'}, {value: 'JN', text: '较难'}, {value: 'FCN', text: '非常难'}];//试题难度
            // 题库
            this.gettkList();
            // 题库数据
            this.tkList = [];
            // 默认查询
            this.model.questionList.forEach((item)=>{
                // 进入页面调用（）查题数
                this.$http.post('/htgl/biz/zypx/sj/zhcy/cxst', {kcId: this.$route.query.kcId, stlb: item.stlb  }).then(res => {
                    item.zsl = res.data.total;
                });
            });
            // 回显数据
            this.$http.post('/htgl/biz/zypx/sj/zhcy/xq',{sjId:this.$route.query.id}).then(res=>{
                if (res.data.paper === null){
                    return false
                }
                this.flList = res.data.paper.sections;
                // 及格分数回显
                this.model.jgfs = res.data.paper.jgf;
                // 卷面总分回显
                this.model.jmzf = res.data.paper.jmzf;
                this.model.questionList.forEach( (tub) =>{
                    this.flList.forEach((item)=>{
                        if (tub.stlb === item.trealType) {
                            tub.stnd = item.tlevel;
                            tub.tkId = item.tdbid;
                            tub.sl = item.tnum;
                            tub.fz = item.tscore
                        }
                    });
                } )
            });
        },
        methods: {
            // 点击试题难度
            changeND(stlb, stnd, tkId){
                let model = {};
                if(stnd){
                    model = {stlb: stlb, stnd: stnd, kcId: this.$route.query.kcId,};
                } else {
                    model = {stlb: stlb, stnd: stnd, tkId: tkId, kcId: this.$route.query.kcId,};
                }
                this.$http.post('/htgl/biz/zypx/sj/zhcy/cxst',model).then(res=>{
                    let zsl = res.data.total;
                    this.model.questionList.forEach(item=>{
                        if(item.stlb == stlb){
                            item.zsl = zsl;
                        }
                    });
                });
                this.model.questionList.forEach(item=>{
                    if (item.stlb === stlb) {
                        item.tkId = '';
                        item.fz = 0;
                        item.sl = 0;
                        this.anewTotalScore()
                    }
                })
            },
            // 点击题库
            changeTk(stlb, tkId, stnd){
                let model = {};
                if(tkId){
                    model = {stlb: stlb, stnd: stnd, tkId: tkId, kcId: this.$route.query.kcId,};
                }else {
                    model = {stlb: stlb, stnd: stnd, kcId: this.$route.query.kcId,};
                }
                this.$http.post('/htgl/biz/zypx/sj/zhcy/cxst',model).then(res=>{
                    let zsl = res.data.total;
                    this.model.questionList.forEach(item=>{
                        if(item.stlb == stlb){
                            item.zsl = zsl;
                        }
                    });
                });
                this.model.questionList.forEach(item=>{
                    if (item.stlb === stlb) {
                        item.fz = 0;
                        item.sl = 0;
                        this.anewTotalScore()
                    }
                })
            },
            // 判断题目超过总数
            verifyCount(stlb, sl, zsl){
                if(sl > zsl){
                    this.$error("数量超过总题目数！");
                    this.model.questionList.forEach(item=>{
                        if(item.stlb == stlb){
                            item.sl = 0;
                        }
                    });
                }
            },
            // 试题难度改变重新计算总分/及格分
            anewTotalScore(){
                let totalPointsList = [];
                this.model.questionList.forEach(item=>{
                    let sjzf = item.sl * item.fz;
                    totalPointsList.push(sjzf);
                    this.model.jmzf = totalPointsList.reduce((a, b)=>a + b);
                    this.model.jgfs = Math.ceil(this.model.jmzf * 0.6);
                });
            },
            // 计算总分/及格分
            updateTotalScore(){
                var totalScore = 0;
                var rnums = $("[name='sl']");
                var rscore = $("[name='fz']");
                for(var i=0;i<rnums.length;i++){
                    totalScore = totalScore + (rnums.eq(i).val() - 0) * (rscore.eq(i).val() - 0);
                }
                var passScore = Math.ceil(totalScore * 0.6);
                this.model.jmzf = totalScore;
                this.model.jgfs = passScore;
            },
            // 题库下拉
            gettkList(){
                const kcId = this.$route.query.kcId;
                this.$http.post('/htgl/biz/zypx/sj/zhcy/hqtk',{ kcId:kcId }).then(res=>{
                    this.tkList = res.data;
                });
            },
            // 提交
            save:function(){
                let luck = true;
                this.model.questionList.forEach( item => {
                    if (item.sl > 0 && (item.fz === null || item.fz <= 0 ) )  {
                        this.$error('请输入每题分值');
                        luck = false;
                        return false
                    }
                    if (item.fz > 0 && (item.sl === null || item.sl <= 0 ) )  {
                        this.$error('请输入数量');
                        luck = false;
                        return false
                    }
                    if (item.tkId && (item.sl === null || item.sl <= 0) ) {
                        this.$error('请填写数量');
                        luck = false;
                        return false
                    }
                });
                if (luck) {
                    let poUrl = '/htgl/biz/zypx/sj/zhcy/pzmb';
                    this.$http.post(poUrl,JSON.stringify(this.model),{'Content-Type':'application/json;charset=UTF-8'}).then(res=>{
                        if (res.code == 0) {
                            this.$success('操作成功',()=>{
                                this.$router.push({name:'HomeworkPaperList'})
                            })
                        }
                    });
                }
            },
            // 取消
            cancel() {
                this.$router.go(-1);
            }
        }

    }
</script>
<style scoped>
    .ly {
        font-size: 16px;
        padding: 10px;
        font-weight: bold;
    }
</style>
